import { useEffect, useMemo, useState } from "react";
import { useI18nStore } from "@companion-core/shared/app/Store/i18nStore";
import { useTabContainerStore } from "@companion-core/shared/app/Store/tabContainerStore";

export const useTabContainer = () => {
  const { locale: lang } = useI18nStore((state) => ({ locale: state.locale }));
  const { tabs } = useTabContainerStore((state) => ({
    tabs: state.tabs,
  }));
  const [activeTab, setActiveTab] = useState<string>();
  const orderedTabs = useMemo(() => tabs.sort((tabA, tabB) => tabA.order - tabB.order), [tabs]);

  useEffect(() => {
    if (orderedTabs.length) {
      setActiveTab(orderedTabs[0].slug);
    }
  }, [orderedTabs]);

  return {
    activeTab,
    setActiveTab,
    lang,
    orderedTabs,
  };
};
